import React from 'react'
import styled from 'styled-components'

import { Icon } from './'

const Button = styled.button`
  border: none;
  background: none;

  > * {
    pointer-events: none;
  }
`

const Text = styled.span`
  padding-left: 3px;
`

export const IconButton = ({onClick, icon, children, className, title, ...rest}) => (
  <Button type="button" onClick={onClick} className={className} title={title}>
    <Icon name={icon} {...rest} />
    <Text>{children}</Text>
  </Button>
)
